namespace GeniuzPOS.ReportMasterData {
    export interface Report_1501_NForm {
        Year: Serenity.LookupEditor;
        CatCode: Serenity.StringEditor;
        CatName: Serenity.StringEditor;
    }

    export class Report_1501_NForm extends Serenity.PrefixedContext {
        static formKey = 'ReportMasterData.Report_1501_N';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!Report_1501_NForm.init)  {
                Report_1501_NForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;

                Q.initFormType(Report_1501_NForm, [
                    'Year', w0,
                    'CatCode', w1,
                    'CatName', w1
                ]);
            }
        }
    }
}
